<template>  
 <div class="d-flex flex-column full-height">
  
    <div class="d-flex justify-content-begin flex-fill full-width">
      <div class="d-flex justify-content full-width">
        <div class="m-1 col-sm-2">
          <div>
            <router-link to="/admin/user">
           客户管理

          </router-link>
          </div>
          <div class="mt-1">
            <router-link to="/admin/note">
              客户待发帖子管理

          </router-link>
          </div>
          <div class="mt-1">
            <router-link to="/admin/saidao">
              赛道对标账号管理

          </router-link>
          </div>
          <!-- <div class="mt-1">
            <router-link to="/admin/tutors">
              PHD导师管理

          </router-link>
          </div>
          <div class="mt-1">
            <router-link to="/admin/cks">
              爬虫ck管理

          </router-link>
          </div> -->

         
        </div>
        <div style=" background-color: #EEF1F8;" class="flex-fill">
         
            <router-view></router-view>
          
          
        </div>

      </div>
    
  </div>
  </div>
  
  </template>
  
  <script>
  
  
  import axios from 'axios';
  
  
  export default {
    data(){
      
      return {
      }
      
    },
   
    components: {
     

    },
     setup(){
      
       var token=localStorage.getItem('sessionToken')
       axios.defaults.headers.common['X-Parse-Session-Token'] = token
  
    },
  
   
    mounted(){
      var token=localStorage.getItem('sessionToken');
      this.role=localStorage.getItem('role');
  
       if(token==undefined || token==null ||token=='')
       {
          this.$router.push('/index')
          return
       }
      
    },
    methods:{
    }
     
    
  };
  </script>
  <style scoped>
  
  .account_icon{
    width: 28px;
  height: 28px;
  border-radius: 28px;
  }
  
  .operationIcon{
    width:24px;
    height:24px;
    cursor:pointer
  }
  
  .textbox_label{
    align-self: stretch;
   color: #262626;
   font-family: "Alibaba PuHuiTi";
   font-size: 14px;
   font-style: normal;
   font-weight: 400;
   line-height: normal;
  }
  .textBox{
    width:300px;
  }
  
  .dropdown{
    width: 130px;
  }
  
  .submitBtn{
  
   width: 300px;
  }
  
  .error-message{
    color:red
  }
  </style>
  
  
  